import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PlayerRewindIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "PlayerRewind",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m2.69 17.54 11.64 9.31a1.24 1.24 0 0 0 1.47.07c.45-.37.74-.92.74-1.55v-7.51l11.25 8.99a1.24 1.24 0 0 0 1.47.07c.45-.37.74-.92.74-1.55V6.67c0-.63-.28-1.19-.73-1.57-.2-.14-.44-.22-.7-.22h-.04c-.28 0-.54.11-.73.3l-11.25 8.97V6.67c0-.63-.28-1.19-.73-1.57-.2-.14-.44-.22-.71-.22h-.04c-.28 0-.54.11-.73.3L2.69 14.43c-.42.37-.68.91-.68 1.51v.13c0 .59.26 1.11.68 1.46Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M15.29 26.57 5 16.29 15.29 6z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.29 27.71c-.3 0-.59-.12-.81-.33L4.19 17.09a1.16 1.16 0 0 1 0-1.62L14.48 5.19c.33-.33.82-.43 1.25-.25s.71.59.71 1.06v20.57a1.154 1.154 0 0 1-1.15 1.15ZM6.62 16.29l7.53 7.53V8.77L6.62 16.3ZM27.29 26.57 17 16.29 27.29 6z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M27.29 27.71c-.3 0-.59-.12-.81-.33L16.19 17.09a1.16 1.16 0 0 1 0-1.62L26.48 5.18c.33-.33.82-.43 1.25-.25s.71.59.71 1.06v20.57a1.154 1.154 0 0 1-1.15 1.15m-8.67-11.42 7.53 7.53V8.77l-7.53 7.53Z"
      })]
    })
  }));
};